var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{attrs:{"value":_vm.promises.fetchOne,"theme":"default"}},[_c('Statistics',{attrs:{"item":_vm.item,"addons":_vm.addons,"items":_vm.items,"type":"page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }